import { useRef } from 'react'
import { useFormState } from 'react-final-form'
import { Button } from '.'
import type { ButtonProps } from '.'
import type { ReactNode } from 'react'

interface SubmitProps extends ButtonProps {
  children: ReactNode
  disabled?: boolean
  ignoreValidation?: boolean
}

export function Submit({
  children,
  disabled = false,
  ignoreValidation = false,
  ...props
}: SubmitProps) {
  const ref = useRef<HTMLButtonElement | null>(null)

  const { submitting, hasValidationErrors: hasFormValidationErrors } =
    useFormState()
  const hasValidationErrors = ignoreValidation ? false : hasFormValidationErrors

  return (
    <Button
      ref={ref}
      {...props}
      submit
      isProgress={submitting}
      disabled={disabled || hasValidationErrors}
    >
      {children}
    </Button>
  )
}
